export default __webpack_public_path__ + "static/media/oslo-policy-summary.ba6675a2.pdf";